export const Constants = {
  ConfirmRegistrationTitle: 'Επιβεβαίωση και Καταχώρηση Στοιχείων',
  CompanyDetails: 'Στοιχεία Επιχείρησης',
  CompanyHeadquarter: 'Έδρα Επιχείρησης',
  ContactDetails: 'Στοιχεία Επικοινωνίας',
  BackToLogin: 'Επιστροφή στην Είσοδο',
  Submit: 'Υποβολή',
  CompanyName: 'Επωνυμία Επιχείρησης',
  EstablishmentDate: 'Ημερομηνία Ίδρυσης',
  TaxIdentificationNumber: 'Α.Φ.Μ. Επιχείρησης',
  CompanySize: 'Μέγεθος Επιχείρησης',
  MainActivityCode: 'ΚΑΔ Κύριας Δραστηριότητας',
  LegalForm: 'Νομική Μορφή',
  StreetNumberHeadquarters: 'Οδός-Αριθμός Έδρας',
  PostalCode: 'Τ.Κ. Έδρας',
  Website: 'Ιστόχωρος',
  TaxOffice: 'ΔΟΥ',
  Number: 'Τηλέφωνο',
  Email: 'Email',
  FirstName: 'Όνομα',
  LastName: 'Επίθετο',
  Occupation: 'Επάγγελμα',
  PhoneNumber: 'Κινητό Τηλέφωνο',
  InfoCompanySize:
    'Σύμφωνα με τη σύσταση 2003/361 της Επιτροπής, οι πολύ μικρές και μικρές επιχειρήσεις είναι εταιρείες που ο αριθμός του προσωπικού τους και το οικονομικό βάρος τους δεν ξεπερνούν ορισμένα όρια:',
  InfoCompanySizeSmall:
    'Πολύ Μικρή Επιχείρηση:  Έως και 10 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών και/ή Ισολογισμός  <= 10.000.000,00€',
  InfoCompanySizeBig:
    'Μικρή Επιχείρηση: Έως και 50 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών και/ή Ισολογισμός <= 10.000.000,00€',
  Search: 'Αναζήτηση',
  Clear: 'Καθαρισμός',
  NoDataFound: 'Δεν βρέθηκαν αποτελέσματα',
  Here: 'εδώ',
  AISearchFileName: 'Δαπάνες Επένδυσης',
  AIDrivenSearch: 'AI Driven Search',
  PoweredBy: 'Powered by Grant Thornton',
  DrivenSearchExplanation:
    'Συμπλήρωσε τα στοιχεία του πελάτη σου για να βρεις τα προγράμματα που του ταιριάζουν καλύτερα.',
  Expenses: 'Δαπάνες',
  DownloadSample: 'Κατέβασε το υπόδειγμα',
  from: 'Από',
  to: 'Έως',
  Close: 'Κλείσιμο',
};
